import { useCallback, useState } from "react";

import SignupViewAPI from "Signups/SignupView/API.js";
import { useSignups } from "Signups/state";

function useCurrentSignupItem() {
  const [state, dispatch] = useSignups();

  const signupItem = state?.currentSignupItem;
  const setSignupItem = useCallback(
    (item) => {
      dispatch({
        type: "setCurrentSignupItem",
        payload: item,
      });
    },
    [dispatch]
  );

  return { signupItem, setSignupItem };
}

function useGetSignupItem() {
  const { signupItem, setSignupItem } = useCurrentSignupItem();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();

  const getSignupItem = useCallback(
    function (signupItemID) {
      if (signupItemID === "new") {
        setSignupItem({ ID: "new" });
        return;
      }

      setIsLoading(true);
      setError(undefined);

      SignupViewAPI.viewItem({ signupListItemID: signupItemID })
        .post()
        .then((res) => {
          setSignupItem(res);
        })
        .catch((err) => {
          console.log(err);
          setError(err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    },
    [setSignupItem]
  );

  return { signupItem, isLoading, error, setSignupItem, getSignupItem };
}

export const signupItemStateHooks = {
  useGetSignupItem,
  useCurrentSignupItem,
};
